import { customerCode, MainRequest } from "./index";
import qs from "querystring";
import Config from "../config";
import axios from "axios";

// 登录方式
export enum LoginType {
    CAS = "1",
    Form = "0",
    Old = "2"
}

interface LoginMethod {
    unifyAuthLogin: BooleanValue; //是否统一认证方式登录（0否1是）
    normalAuthLogin: BooleanValue; //是否普通登录（0否1是）
    dynamicCertLogin: BooleanValue; //是否动态凭证登录（0否1是）
}

/**
 * 获取可登录类型
 */
export function getLoginMethodSet() {
    return MainRequest.get<SuccessData<LoginMethod>>(
        `/student/getLoginMethodSet`
    ).then(res => res.data.data);
}

/**
 * 登录失败次数
 * @param studentNo
 */
export const getLoginCount = (studentNo: string) => {
    return MainRequest.get(`/student/getLoginCount`, {
        params: { studentNo: studentNo?.trim() }
    }).then(res => res.data.data);
};

export interface LoginUnifySetItem {
    loginUrl: string; //统一认证登录地址url
    rollBackUrl: string; //回调地址
    responseType: string; //认证模式（目前固定code）
    clientId: string; //应用标识
    clientSecret: string; //应用密码
    scope: string; //作用域
    state: string; //应用状态
    changePasswordUrl: string; //修改密码地址
}

/**
 * 学生端-获取统一身份认证参数
 */
export const getLoginUnifySet = () => {
    return MainRequest.get<SuccessData<LoginUnifySetItem>>(
        "/student/getLoginUnifySet"
    ).then(res => res.data.data);
};

/**
 * 判断参数拼接成url
 * @param args
 */
export function buildURL(...args: string[]) {
    // 使用 reduce 方法将参数过滤为有值的部分，并拼接成 URL
    return args.reduce((acc, curr) => {
        const curVal = curr.split("=").pop();
        if (curVal) {
            // 如果参数有值，则添加到 URL 中
            if (acc) {
                return `${acc}&${curr}`;
            } else {
                return curr;
            }
        } else {
            // 如果参数没有值，则跳过该参数
            return acc;
        }
    }, "");
}

function keepLoginInfo(data: {
    user: string;
    STUDENTNO: string;
    STUDENTNAME: string;
    token: string;
    LoginType: LoginType;
    userType: LoginType;
}) {
    for (const key in data) {
        localStorage.setItem(key, data[key as keyof typeof data]);
    }

    if (!data.LoginType) {
        localStorage.setItem("LoginType", LoginType.Old);
    }
}

export async function logout() {
    if (window.ReactNativeWebView) {
        return window.ReactNativeWebView.postMessage("logout");
    }

    const loginType = localStorage.getItem("LoginType");

    const data = await getLoginUnifySet();

    localStorage.clear();

    if (loginType === LoginType.Old) {
        window.location.href = `/login/old`;
    } else if (loginType === LoginType.CAS) {
        window.location.href = `https://sso.dufe.edu.cn/auth/user/logout?client_id=${data?.clientId}`;
    } else {
        window.location.href = `/login`;
    }
}

/**
 * 普通登录
 * @param url 接口路径
 * @param username
 * @param password
 * @param code
 */
export const login = async (
    url: string,
    username: string,
    password: string,
    code?: string
) => {
    const res = await MainRequest.post(
        url,
        qs.stringify({
            username: username?.trim(),
            password: password?.trim(),
            code: code?.trim(),
            customerCode: Config.CustomCode
        })
    );

    const data = res.data.data;

    keepLoginInfo({
        token: data.token,
        user: username?.trim(),
        STUDENTNO: data.studentNo,
        STUDENTNAME: data.studentName,
        userType: data.type,
        LoginType: data.loginType
    });
};

/**
 * 统一身份认证登录
 * @param code
 */
export const authLogin = (code: string) => {
    return MainRequest.post("/student/authLogin", qs.stringify({ code }))
        .then(res => res.data)
        .then(res => {
            keepLoginInfo({
                token: res.data.token,
                user: res.data.studentNo,
                STUDENTNO: res.data.studentNo,
                STUDENTNAME: res.data.studentName,
                userType: res.data.type,
                LoginType: res.data.loginType
            });

            return res;
        });
};

export const resetPwd = (studentNo: string, name: string, cardId: string) => {
    return axios.post(
        "/student/resetPwd",
        qs.stringify({
            studentNo: studentNo,
            name: name,
            cardId: cardId,
            customerCode: customerCode
        })
    );
};

export const changePwd = (password: string, newPassword: string) => {
    return MainRequest.post(
        "/student/changePwd",
        qs.stringify({ pwd: password?.trim(), newPwd: newPassword?.trim() })
    ).then(res => res.data);
};
